import React, { useState } from 'react';
import { Package, X, ShoppingCart } from 'lucide-react';
import { useCart } from '../../../context/CartContext';
import './EquipmentCard.css';

const EquipmentCard = ({ equipment }) => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart({
      id: equipment.id,
      type: 'equipment',
      name: equipment.name,
      price: equipment.price,
      data: equipment,
      image: equipment.image,
    });
    setShowModal(false);
  };

  return (
    <>
      {/* Card */}
      <div className="equipment-card" onClick={() => setShowModal(true)}>
        <div className="eq-card-image">
          {equipment.image ? (
            <img src={equipment.image} alt={`${equipment.name} - ${equipment.category || 'Film'} equipment for rent`} />
          ) : (
            <div className="eq-card-placeholder">
              <Package size={40} />
            </div>
          )}
          {!equipment.available && (
            <div className="eq-card-badge">Unavailable</div>
          )}
        </div>
        <div className="eq-card-content">
          <div className="eq-card-category">{equipment.category}</div>
          <h3 className="eq-card-title">{equipment.name}</h3>
          {equipment.brand && (
            <p className="eq-card-meta">{equipment.brand} {equipment.model}</p>
          )}
          <div className="eq-card-footer">
            <span className="eq-card-price">${equipment.price}/day</span>
            <span className="eq-card-link">View Details →</span>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="eq-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="eq-modal" onClick={(e) => e.stopPropagation()}>
            <button className="eq-modal-close" onClick={() => setShowModal(false)}>
              <X size={24} />
            </button>

            <div className="eq-modal-grid">
              {/* Image */}
              <div className="eq-modal-image">
                {equipment.image ? (
                  <img src={equipment.image} alt={`${equipment.name} - ${equipment.category || 'Film'} equipment for rent`} />
                ) : (
                  <div className="eq-modal-placeholder">
                    <Package size={64} />
                  </div>
                )}
              </div>

              {/* Details */}
              <div className="eq-modal-details">
                <div className="eq-modal-category">{equipment.category}</div>
                <h2 className="eq-modal-title">{equipment.name}</h2>
                
                {equipment.brand && (
                  <p className="eq-modal-brand">{equipment.brand} {equipment.model}</p>
                )}

                <div className="eq-modal-info">
                  <div className="eq-info-row">
                    <span className="eq-info-label">Condition:</span>
                    <span className="eq-info-value">{equipment.condition}</span>
                  </div>
                  <div className="eq-info-row">
                    <span className="eq-info-label">Quantity:</span>
                    <span className="eq-info-value">{equipment.quantity}</span>
                  </div>
                  <div className="eq-info-row">
                    <span className="eq-info-label">Status:</span>
                    <span className={`eq-info-value ${equipment.available ? 'available' : 'unavailable'}`}>
                      {equipment.available ? 'Available' : 'Unavailable'}
                    </span>
                  </div>
                </div>

                {equipment.description && (
                  <div className="eq-modal-description">
                    <h4>Description</h4>
                    <p>{equipment.description}</p>
                  </div>
                )}

                <div className="eq-modal-actions">
                  <div className="eq-modal-price">
                    <span className="eq-price-label">Daily Rate</span>
                    <span className="eq-price-value">${equipment.price}</span>
                  </div>
                  <button 
                    onClick={handleAddToCart}
                    className="btn btn-primary"
                    disabled={!equipment.available}
                  >
                    <ShoppingCart size={18} />
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EquipmentCard;